
jQuery(function ($) {

  $(document).on("click", ".btn_send", function () {
    $('.btn_target').addClass('btn_disabled');
  });

});
